import { Trans } from '@lingui/macro'

import * as React from 'react'

import { WebLink } from '~ui/components/WebLink/WebLink'

import { FooterSectionText } from './FooterSectionText'

type TProps = NoChildren

/**
 * Illustrations attribution used in the footer section.
 * */
export const IllustrationsAttribution: React.FC<TProps> = () => {
  return (
    <FooterSectionText>
      <Trans>Illustrations by</Trans> <WebLink url={`https://storyset.com/`}>Storyset</WebLink>
    </FooterSectionText>
  )
}
